import { Component, ViewChild }      from '@angular/core';
import { Router }         from '@angular/router';
import { BreadcrumbPath } from 'source/app/controls/components/breadcrumb/breadcrumb-path';


@Component({
    templateUrl: './breadcrumb.html'
})
export class BreadcrumbComponent {

    constructor(private router: Router) {
        this.Path = this.router.url;
    }

    Path;

    OnLinkClick(crumb: BreadcrumbPath) {
        this.router.navigate([crumb.Path]);
    }

    @ViewChild(BreadcrumbComponent) BreadcrumbControl: BreadcrumbComponent;
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/breadcrumb/breadcrumb-component.ts